import React, { useState, useEffect } from "react";
import AdvisorMainContent from "../layout/AdvisorMain";
import AdvisorCmtsAndRecmndtns from "../components/Advisors/AdvisorCmtsAndRecmndtns";
import { Switch } from "antd";
import leftarrow from "../assets/images/u_angle-left-b.svg";
import plus from "../assets/images/fi_plus.svg";
import { useNavigate } from "react-router-dom";
import { Radio, Select } from "antd";
import AdvisorReviewModal from "./AdvisorReviewModal";
import { apiServices } from "../services/Api";

const { Option } = Select;

const TradeCall = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [riskRewardRatio, setRiskRewardRatio] = useState("");
  const [epl, setEpl] = useState("");
  const [sl, setSl] = useState("");
  const [tp, setTp] = useState("");

  const [uniqueNames, setUniqueNames] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const initialModalData = {
    tradingSymbol: "",
    transactionType: "SELL",
    confidence: "",
    mode: "overnight",
    entryPriceLower: "",
    entryPriceUpper: "",
    holdingDurationInDays: "",
    targetPrice: "",
    stoploss: "",
    fundsMargin: "1",
    risk: "",
    reward: "",
    comments: [],
    recommendations: [],
  };

  const [modalData, setModalData] = useState({ ...initialModalData });

  useEffect(() => {
    console.log("modal data updated: ", modalData);
  }, [modalData]);

  const [tradingSymbolError, setTradingSymbolError] = useState(false);
  const [confidenceError, setConfidenceError] = useState(false);
  const [entryPriceLowerError, setEntryPriceLowerError] = useState(false);
  const [entryPriceUpperError, setEntryPriceUpperError] = useState(false);
  const [holdingDurationInDaysError, setHoldingDurationInDaysError] =
    useState(false);
  const [targetPriceError, setTargetPriceError] = useState(false);
  const [stopLossError, setStopLossError] = useState(false);

  // const [riskError, setRiskError] = useState(false);
  // const [rewardError, setRewardError] = useState(false);

  const resetForm = () => {
    setModalData({ ...initialModalData });
    setLogic([]);
    setRecommendation([]);
    setUniqueNames([]);
    setSearchLoading(false);
    setEpl("");
    setSl("");
    setTp("");
    setRiskRewardRatio("");
    setTradingSymbolError(false);
    setConfidenceError(false);
    setEntryPriceLowerError(false);
    setEntryPriceUpperError(false);
    setHoldingDurationInDaysError(false);
    setTargetPriceError(false);
    setStopLossError(false);
  };

  const openModal = () => {
    // Assume no errors initially
    let hasError = false;

    if (modalData.tradingSymbol === "") {
      setTradingSymbolError(true);
      hasError = true;
    } else {
      setTradingSymbolError(false);
    }

    if (modalData.confidence === "") {
      setConfidenceError(true);
      hasError = true;
    } else {
      setConfidenceError(false);
    }

    if (modalData.entryPriceLower === "" || modalData.entryPriceUpper === "") {
      setEntryPriceLowerError(true);
      setEntryPriceUpperError(true);
      hasError = true;
    } else {
      setEntryPriceLowerError(modalData.entryPriceLower === "");
      setEntryPriceUpperError(modalData.entryPriceUpper === "");
    }

    if (modalData.holdingDurationInDays === "") {
      setHoldingDurationInDaysError(true);
      hasError = true;
    } else {
      setHoldingDurationInDaysError(false);
    }

    if (modalData.targetPrice === "") {
      setTargetPriceError(true);
      hasError = true;
    } else {
      setTargetPriceError(false);
    }

    if (modalData.stoploss === "") {
      setStopLossError(true);
      hasError = true;
    } else {
      setStopLossError(false);
    }

    // if (modalData.risk === "" || modalData.reward === "") {
    //   setRiskError(true);
    //   setRewardError(true);
    //   hasError = true;
    // } else {
    //   setRiskError(modalData.risk === "");
    //   setRewardError(modalData.reward === "");
    // }

    // If no errors, update logic/recommendations and open the modal
    if (!hasError) {
      updateLogicRecommendation();

      setTimeout(() => {
        setIsModalOpen(true);
      }, 100);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onChange = (checked) => {
    const transactionType = checked === true ? "SELL" : "BUY";
    setModalData((data) => ({
      ...data,
      transactionType: transactionType,
    }));
    console.log(`switch to ${transactionType}`);
  };

  const onChangeSelect = (value, option) => {
    console.log("Selected:", value, option);
    setModalData((data) => ({
      ...data,
      tradingSymbol: value,
      instrumentToken: option?.instrumentToken || "",
    }));
  };

  const onSearchSelect = async (value) => {
    console.log("search:", value);

    // Clear results if search is empty
    if (!value || value.trim().length === 0) {
      setUniqueNames([]);
      return;
    }

    try {
      setSearchLoading(true);
      const response = await apiServices.get(
        `instruments/search?query=${encodeURIComponent(value.trim())}`
      );
      console.log("Search results:", response);

      if (Array.isArray(response)) {
        setUniqueNames(response);
      } else {
        setUniqueNames([]);
      }
    } catch (error) {
      console.error("Error searching instruments:", error);
      setUniqueNames([]);
    } finally {
      setSearchLoading(false);
    }
  };

  const filterOption = () => true;

  const handleModeChange = (event) => {
    setModalData((data) => ({
      ...data,
      mode: event.target.value,
    }));
    // console.log('mode:', event.target.value);
  };
  const handleConfidenceChange = (event) => {
    setModalData((data) => ({
      ...data,
      confidence: event.target.value,
    }));
  };

  const handleEntryPriceLower = (event) => {
    setEpl(event.target.value);
    setModalData((data) => ({
      ...data,
      entryPriceLower: event.target.value,
    }));
  };

  const handleEntryPriceUpper = (event) => {
    setModalData((data) => ({
      ...data,
      entryPriceUpper: event.target.value,
    }));
  };

  const handleTargetDuration = (event) => {
    setModalData((data) => ({
      ...data,
      holdingDurationInDays: event.target.value,
    }));
  };

  const handleTargetPrice = (event) => {
    setTp(event.target.value);
    setModalData((data) => ({
      ...data,
      targetPrice: event.target.value,
    }));
  };

  const handleStopLoss = (event) => {
    setSl(event.target.value);
    setModalData((data) => ({
      ...data,
      stoploss: event.target.value,
    }));
  };

  function calculateRatio(entryL, stoploss, target) {
    if (entryL && stoploss && target) {
      return ((entryL - stoploss) / (target - entryL)).toFixed(2);
    }
  }

  function formatRatio(ratio) {
    if (ratio) {
      const fraction = parseFloat(ratio); // Convert ratio to float
      const precision = 1e9; // Precision for rounding

      let numerator = Math.round(fraction * precision);
      let denominator = precision;

      // Find greatest common divisor (GCD) to simplify the fraction
      const gcd = (a, b) => (b ? gcd(b, a % b) : a);
      const gcdValue = gcd(numerator, denominator);

      numerator /= gcdValue;
      denominator /= gcdValue;

      return { risk: numerator, reward: denominator };
    }
  }

  useEffect(() => {
    const ratio = calculateRatio(epl, sl, tp);
    if (ratio) {
      const formattedRatio = formatRatio(ratio);
      if (formattedRatio) {
        setModalData((data) => ({
          ...data,
          risk: "1",
          reward: (formattedRatio.reward / formattedRatio.risk).toFixed(2),
        }));
      }
      setRiskRewardRatio(
        `1 : ${(formattedRatio.reward / formattedRatio.risk).toFixed(2)}`
      );
    } else {
      setRiskRewardRatio("");
      setModalData((data) => ({
        ...data,
        risk: "",
        reward: "",
      }));
    }
  }, [epl, sl, tp]);

  const [logic, setLogic] = useState([]); // To store logics
  const [recommendation, setRecommendation] = useState([]); // To store recommendations

  const updateLogicRecommendation = () => {
    setModalData((data) => ({
      ...data,
      comments: JSON.stringify(logic),
      recommendations: JSON.stringify(recommendation),
    }));
  };

  const handlePublishCall = async () => {
    try {
      const response = await apiServices.post("/advisors/calls", {
        tradingSymbol: modalData.tradingSymbol,
        instrumentToken: modalData.instrumentToken || "",
        entryPriceLower: parseFloat(modalData.entryPriceLower),
        entryPriceUpper: parseFloat(modalData.entryPriceUpper),
        targetPrice: parseFloat(modalData.targetPrice),
        stoploss: parseFloat(modalData.stoploss),
        duration: modalData.holdingDurationInDays,
        confidence: modalData.confidence,
        transactionType: modalData.transactionType,
        tradeType: modalData.mode === "overnight" ? "OVERNIGHT" : "INTRADAY",
        comments: JSON.stringify(logic),
        recommendations: JSON.stringify(recommendation),
      });

      // Show message based on response payload
      const success = response?.success ?? true; // assume true if backend returns created entity
      const message =
        response?.message ||
        (success ? "Call published successfully" : "Failed to publish call");
      if (success) {
        setIsModalOpen(false);
        resetForm();
        alert(message);
      } else {
        alert(message);
      }
    } catch (err) {
      console.log("API Error:", err.message);
      alert(err?.message || "API call failed!");
    }
  };

  return (
    <AdvisorMainContent>
      <div className="max-w-[1200px] md:max-w-[1100px] lg:max-w-[1200px] mx-auto px-4 sm:px-6 md:px-8 lg:px-8 py-6 md:py-8 lg:py-8">
        {/* Header Card */}
        <div className="bg-white rounded-lg border border-brand-border p-4 md:p-5 lg:p-6 mb-6">
          <div className="flex flex-col sm:flex-row md:flex-row items-start sm:items-center md:items-center justify-between gap-4 md:gap-5 lg:gap-6">
            <div className="flex items-center gap-3 md:gap-4 lg:gap-4">
              <button
                onClick={() => navigate("/advisordashboard")}
                className="flex items-center justify-center w-10 h-10 lg:w-12 lg:h-12 rounded-lg border border-gray-400 bg-white hover:bg-gray-50 transition-colors"
              >
                <img
                  src={leftarrow}
                  alt="back"
                  className="w-5 h-5 lg:w-6 lg:h-6"
                />
              </button>
              <h1 className="text-lg md:text-xl lg:text-xl font-bold text-[#454545]">
                Create new Trade Call
              </h1>
            </div>
            <button
              type="button"
              onClick={openModal}
              className="w-full sm:w-auto md:w-auto px-6 md:px-7 lg:px-8 py-2.5 md:py-2.5 lg:py-3 bg-primary hover:bg-primary/90 text-white text-sm md:text-sm lg:text-base font-medium rounded-lg transition-colors"
            >
              Review & Publish
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-brand-border p-4 md:p-5 lg:p-6 mb-6">
          <h2 className="text-base md:text-lg lg:text-lg font-semibold text-[#454545] mb-4 md:mb-5 lg:mb-6">
            Trade call details
          </h2>

          <div className="w-full space-y-6">
            <div className="flex items-center gap-3">
              <span className="text-sm lg:text-base font-medium text-[#454545]">
                BUY
              </span>
              <Switch
                checked={modalData.transactionType === "SELL"}
                onChange={onChange}
                style={{
                  backgroundColor:
                    modalData.transactionType === "SELL"
                      ? "#D41414"
                      : "#1E8C45",
                }}
              />
              <span className="text-sm lg:text-base font-medium text-[#454545]">
                SELL
              </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Scrip Name
                </label>
                <Select
                  showSearch
                  placeholder="Search"
                  optionFilterProp="children"
                  value={modalData.tradingSymbol || undefined}
                  onChange={onChangeSelect}
                  onSearch={onSearchSelect}
                  filterOption={filterOption}
                  loading={searchLoading}
                  notFoundContent={
                    searchLoading ? "Searching..." : "No results found"
                  }
                  className="w-full"
                >
                  {uniqueNames.map((instrument) => (
                    <Option
                      key={
                        instrument.instrumentToken || instrument.tradingSymbol
                      }
                      value={instrument.tradingSymbol}
                      instrumentToken={instrument.instrumentToken}
                      label={instrument.tradingSymbol}
                    >
                      {instrument.tradingSymbol}
                    </Option>
                  ))}
                </Select>
                {tradingSymbolError && (
                  <span className="text-xs text-red-500">
                    Please select scrip name.
                  </span>
                )}
              </div>

              {/* Confidence */}
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Enter your confidence %
                </label>
                <input
                  onChange={handleConfidenceChange}
                  value={modalData.confidence}
                  type="text"
                  placeholder="Eg. 70%"
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
                {confidenceError && (
                  <span className="text-xs text-red-500">
                    Please enter confidence value.
                  </span>
                )}
              </div>

              {/* Mode */}
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Choose your mode
                </label>
                <Radio.Group
                  name="radiogroup"
                  value={modalData.mode}
                  className="flex flex-wrap gap-4"
                >
                  <Radio value={"overnight"} onChange={handleModeChange}>
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-[#454545]">
                        Overnight
                      </span>
                      <span className="text-xs text-[#616771]">NRML</span>
                    </div>
                  </Radio>
                  <Radio value={"intraday"} onChange={handleModeChange}>
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-[#454545]">
                        Intraday
                      </span>
                      <span className="text-xs text-[#616771]">MIS</span>
                    </div>
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-[#d9d9d9]"></div>

            {/* Entry Price, Target, Stop Loss Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 lg:gap-6">
              {/* Entry Price Range */}
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Entry Price Range
                </label>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    onChange={handleEntryPriceLower}
                    value={modalData.entryPriceLower}
                    placeholder="0000.00"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <span className="text-sm text-[#454545]">to</span>
                  <input
                    type="text"
                    onChange={handleEntryPriceUpper}
                    value={modalData.entryPriceUpper}
                    placeholder="0000.00"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                </div>
                {(entryPriceLowerError || entryPriceUpperError) && (
                  <span className="text-xs text-red-500">
                    Both upper and lower values required.
                  </span>
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Duration
                </label>
                <div className="flex items-center gap-2">
                  <input
                    onChange={handleTargetDuration}
                    value={modalData.holdingDurationInDays}
                    type="text"
                    placeholder="01"
                    className="w-full max-w-[5rem] px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <span className="text-sm text-[#454545]">days</span>
                </div>
                {holdingDurationInDaysError && (
                  <span className="text-xs text-red-500">Required value.</span>
                )}
              </div>

              {/* Target */}
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Target
                </label>
                <input
                  onChange={handleTargetPrice}
                  value={modalData.targetPrice}
                  type="text"
                  placeholder="0000.00"
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
                {targetPriceError && (
                  <span className="text-xs text-red-500">Required value.</span>
                )}
              </div>

              {/* Stop Loss */}
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Stop Loss
                </label>
                <input
                  onChange={handleStopLoss}
                  value={modalData.stoploss}
                  type="text"
                  placeholder="0000.00"
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
                {stopLossError && (
                  <span className="text-xs text-red-500">Required value.</span>
                )}
              </div>
            </div>

            {/* Funds Margin and Risk:Reward Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
              {/* Funds Margin - Commented out as per original */}
              {/* <div className="flex flex-col gap-2">
                      <label className="text-sm font-medium text-[#454545]">Funds Margin</label>
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-[#454545]">X</span>
                        <input
                          defaultValue={1}
                          type="text"
                          placeholder="01"
                          className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                        />
                      </div>
                    </div> */}

              {/* Risk : Reward */}
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-[#454545]">
                  Risk : Reward
                </label>
                <div className="px-3 py-2 border border-gray-200 rounded-lg bg-gray-50">
                  <span className="text-sm text-[#454545]">
                    {riskRewardRatio || "— : —"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button className="flex items-center justify-center gap-2 py-3 px-4 border border-gray-400 rounded-lg bg-white hover:bg-gray-50 transition-colors w-full mb-6 text-sm md:text-sm lg:text-base font-medium text-[#454545]">
          <img src={plus} alt="plus" className="w-5 h-5" />
          <span className="text-sm md:text-sm lg:text-base font-medium text-[#454545]">
            Hedge Trade
          </span>
        </button>

        <div className="bg-white rounded-lg border border-brand-border p-4 md:p-5 lg:p-6">
          <h2 className="text-base md:text-lg lg:text-lg font-semibold text-[#454545] mb-4 md:mb-5 lg:mb-6">
            Add Comments
          </h2>
          <AdvisorCmtsAndRecmndtns
            logic={logic}
            setLogic={setLogic}
            recommendation={recommendation}
            setRecommendation={setRecommendation}
            updateLogicRecommendation={updateLogicRecommendation}
          />
        </div>

        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
              className="absolute inset-0 bg-black bg-opacity-50"
              onClick={closeModal}
            ></div>

            <div className="relative bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto z-10 mx-4 md:mx-0">
              <AdvisorReviewModal data={modalData} showAdvDetails={false} />
              <div className="flex gap-3 md:gap-3 lg:gap-4 p-4 md:p-5 lg:p-6 justify-end border-t border-gray-200 bg-white sticky bottom-0">
                <button
                  onClick={closeModal}
                  className="px-6 py-2.5 rounded-lg bg-white border border-primary text-[#454545] font-medium hover:bg-gray-50 transition-colors"
                >
                  Close
                </button>
                <button
                  onClick={handlePublishCall}
                  className="px-6 py-2.5 rounded-lg bg-primary text-white font-medium hover:bg-primary/80 transition-colors"
                >
                  Publish Call
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdvisorMainContent>
  );
};

export default TradeCall;
